var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('input',{staticStyle:{"opacity":"0","position":"absolute"},attrs:{"id":"custom_copyInput","type":"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }